import { Component, OnInit, ApplicationRef, HostListener } from '@angular/core';
import { LoginDataService } from "app/login/login-data.service";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { NotificationsService } from 'angular2-notifications';
import { FormBuilder, Validators } from '@angular/forms';
import { UserResource } from 'app/models/UserResource';
import { Observable ,  forkJoin } from 'rxjs';
import { HttpClient } from "@angular/common/http";
import { environment } from 'app/baseUrl';
import { LoginVMResource } from 'app/models/LoginVMResource';

@Component({
	selector: 'vbn-login',
	// providers: [LoginDataService],
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

	errorMessage: string;
	loginEmailInput: string
	loginPassInput: string
	saveErrors: boolean = false
	userResource: UserResource;
	errorWrongMail: boolean = false;
	recoverSuccess: boolean = false;
	forgotPassVar: boolean = false;
	capsLock: boolean = false;
	private timer;
	language = localStorage.getItem("vbn-language");

	constructor(private http: HttpClient, private _login: LoginDataService, private _route: Router, private _appRef: ApplicationRef, private translate: TranslateService, private fb: FormBuilder, private _notificationService: NotificationsService) {
		this.loginEmailInput = ""
		this.loginPassInput = ""
		this.userResource = new UserResource();
	}

	loginForm = this.fb.group({
		email: ['', [Validators.required, Validators.email]],
		password: ['', [Validators.required]]
	})

	@HostListener('document:keypress', ['$event'])
	handleKeyboardEvent(event: KeyboardEvent) {
		if (event.keyCode === 13) {
			this.logIn();
		}
	}

	@HostListener('document:keypress', ['$event'])
	capsLockEv(event: KeyboardEvent) {
		let s = String.fromCharCode( event.which );
		if ( s.toUpperCase() === s && s.toLowerCase() !== s && !event.shiftKey ) {
			this.capsLock = true;
		} else {
			this.capsLock = false;
		}
	}

	langToEn() {
		this.translate.setDefaultLang('en')
		this.translate.use('en')
		localStorage.setItem("vbn-language", 'en')
	}


	// langToFr() {
	// 	this.translate.setDefaultLang('fr')
	// 	this.translate.use('fr')
	// 	localStorage.setItem("vbn-language", 'fr')
	// 	this.language = localStorage.getItem("vbn-language");
	// }


	langToRo() {
		this.translate.setDefaultLang('ro')
		this.translate.use('ro')
		localStorage.setItem("vbn-language", 'ro')
		this.language = localStorage.getItem("vbn-language");
	}

	langToFr() {
		this.translate.setDefaultLang('fr')
		this.translate.use('fr')
		localStorage.setItem("vbn-language", 'fr')
		this.language = localStorage.getItem("vbn-language");
	}

	langToDe() {
		this.translate.setDefaultLang('de')
		this.translate.use('de')
		localStorage.setItem("vbn-language", 'de')
		this.language = localStorage.getItem("vbn-language");
	}

	ngOnInit() {
	}

	// logIn() {
	// 	this.saveErrors = true
	// 	if (!this.loginForm.valid) {
	// 		return forkJoin(
	// 				this.translate.get('Mising fields'),
	// 				this.translate.get('Please fill out the fields!')
	// 			).subscribe((res) => {
	// 				this._notificationService.create(res[0], res[1], 'error')
	// 		});

	// 	} 
	// 	this._login.logIn(this.loginEmailInput, this.loginPassInput)
	// 			.subscribe(
	// 			heroes => {
	// 				forkJoin(
	// 						this.translate.get('Success'),
	// 						this.translate.get('Successfully logged in!')
	// 					).subscribe((res) => {
	// 						this._notificationService.create(res[0], res[1], 'success')
	// 				});
	// 			},
	// 			error => {
	// 				return forkJoin(
	// 						this.translate.get('Error'),
	// 						this.translate.get('Email or password are incorrect')
	// 					).subscribe((res) => {
	// 						this._notificationService.create(res[0], res[1], 'error')
	// 				});
	// 			});
	// }

	logIn() {
		this.saveErrors = true
		/* const data = {'username': this.loginEmailInput, 'password': this.loginPassInput};
		const dataStr = JSON.stringify(data);
 */
		const loginVM = new LoginVMResource();
		loginVM.username = this.loginEmailInput;
		loginVM.password = this.loginPassInput;
		console.log('Try login with credentials', loginVM);
		this.http.post(environment['url'] + '/admin/login', loginVM,  {
			observe: 'response'
		}).subscribe(
		(heroes) => {
			console.log('aici login head', heroes.headers),		
			console.log('aici login ', heroes),		
				localStorage.setItem("_x_auth_token", heroes.headers.get('authorization'))
				this.loginEmailInput = this.loginEmailInput.toLowerCase();    
				this._login.validLogin(this.loginEmailInput, () =>{
					this._route.navigate(['/home'])
					forkJoin(
							[this.translate.get('Success'),
							this.translate.get('Successfully logged in!')]
						).subscribe((res) => {
							this._notificationService.create(res[0], res[1], 'success')
					});
				});
				
		},
		err =>{
				return forkJoin(
						this.translate.get('Error'),
						this.translate.get('Email or password are incorrect')
					).subscribe((res) => {
						this._notificationService.create(res[0], res[1], 'error')
				});
			}
	)};

	toHome() {
		this._route.navigate(['/home'])
	}

	date = new Date();

	changePass = this.fb.group({
		forgotEmail: ['', [Validators.required, Validators.email]],
	})

	openForgotPassword() {
		this.forgotPassVar = true;
	}

	backToLogin() {
		this.forgotPassVar = false;
	}

	forgotPass() {
		this.saveErrors = true
		if (this.changePass.invalid) {
			this._notificationService.create("Mising fields", 'Please fill out the fields!', 'error')
			return
		}
		this._login.resetPassword(`/admin/user/resetPassword?email=`+this.userResource.email)
			.subscribe(
			response => {
				if(response.errorCode ===1015){
					forkJoin(
							[this.translate.get('Error'),
							this.translate.get(`Email address doesn't exist`)]
						).subscribe((res) => {
							this._notificationService.create(res[0], res[1], 'error')
						}
						)
				}else{
					this.recoverSuccess = true;
					this.timer = setTimeout(() => {
						this.restRecoverForm();
						this.recoverSuccess = false;
					}, 5000);
				}
			},
			error => {
				this.errorWrongMail = true;
			});
	}

	restRecoverForm() {
		this.saveErrors = false
		this.userResource.email = ""
		this.changePass.reset()
	}

}
